<template>
  <Tooltip :text="$t('interface.aiGeneratedTooltip')">
    <div class="ai-generated-message-label">
      <icon-ai-generated :size="10" />
      <span>{{ $t('interface.aiGeneratedLabel') }}</span>
    </div>
  </Tooltip>
</template>

<script>
import IconAiGenerated from './icons/icons/IconAiGenerated.vue'
import Tooltip from './Tooltip.vue'

export default {
  name: 'AIGeneratedBadge',
  components: {
    IconAiGenerated,
    Tooltip
  }
}
</script>
